export enum EInformationTabSectionKey {
  Section1 = 'Information_Section1',
  Section2 = 'Information_Section2',
  CollabOrgs = 'Information_CollabOrgs',
  Section3 = 'Information_Section3',
  FrequentlyAsks = 'Information_FrequentlyAsks',
}

export interface IInformationTabSection1 {
  image: string;
}

export interface IInformationTabSection2 {
  data: {
    title: string;
    content: string;
  }[];
}

export interface IInformationTabCollabOrgsSection {
  title: string;
  image: string;
}

export interface IInformationTabSection3 {
  title: string;
  content: string;
  image: string;
}

export interface IInformationTabFrequentlyAsksSection {
  questions: {
    question: string;
    answer: string;
  }[];
}

export type TEnterpriseProfileInformationTabSectionElements =
  | IInformationTabSection1
  | IInformationTabSection2
  | IInformationTabCollabOrgsSection
  | IInformationTabSection3
  | IInformationTabFrequentlyAsksSection;

export type TEnterpriseProfileInformationTabSection = {
  sectionName: string;
  sectionKey: EInformationTabSectionKey;
  elements?: TEnterpriseProfileInformationTabSectionElements;
  isActive: boolean;
}[];
